import { render } from "./PressReleasePage.vue?vue&type=template&id=81205fea&scoped=true"
import script from "./PressReleasePage.vue?vue&type=script&lang=js"
export * from "./PressReleasePage.vue?vue&type=script&lang=js"

import "./PressReleasePage.vue?vue&type=style&index=0&id=81205fea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81205fea"]])

export default __exports__